import axiosClient from "./axiosClient";

export const getMenus = async (storeUuid) => {
    try {
        const response = await axiosClient.get(`/stores/${storeUuid}/services`);
        const data = response.data.data;
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.services)) return data.services;
        if (Array.isArray(data?.items)) return data.items;
        return [];
    } catch (error) {
        throw error;
    }
};

export const createMenu = async (storeUuid, data) => {
    try {
        const response = await axiosClient.post(`/stores/${storeUuid}/services`, data);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const updateMenu = async (storeUuid, menuUuid, data) => {
    try {
        const response = await axiosClient.put(`/stores/${storeUuid}/services/${menuUuid}`, data);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const deleteMenu = async (storeUuid, menuUuid) => {
    try {
        const response = await axiosClient.delete(`/stores/${storeUuid}/services/${menuUuid}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
